import { UserType } from '../../../../api/types/user/user-type';
import React from 'react';
import SideBarNew from '../../../../component/side-bar/side-bar-new/side-bar-administration';
import { toast } from 'react-toastify';
import { SideBarProfessor } from '../../../../component/side-bar/side-bar-new/side-bar-professor';
import { SideBarStudent } from '../../../../component/side-bar/side-bar-new/side-bar-student';

export interface SideBarByRoleDatamodel {
  userType: UserType;
}

export const SideBarByRole: React.FC<SideBarByRoleDatamodel> = ({
  userType,
}) => {
  switch (userType) {
    case UserType.STUDENT:
      return <SideBarStudent />;
    case UserType.ADMINISTRATION:
      return <SideBarNew />;
    case UserType.LECTURER:
      return <SideBarProfessor />;
  }
};
